import { Component, OnInit, Input } from '@angular/core';
import { OHNElement } from '../../../models/ohn-instances';

@Component({
  selector: 'app-timer-element-config',
  templateUrl: './timer-element-config.component.html',
  styleUrls: ['./timer-element-config.component.scss'],
})
export class TimerElementConfigComponent implements OnInit {

	@Input() el: OHNElement;

  constructor() { }

  ngOnInit() {}

}
